import { ChangeDetectionStrategy, Component, computed, input, output, ViewChild, AfterViewInit, effect } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { Tooltip, TooltipModule } from 'primeng/tooltip';

@Component({
  standalone: true,
  selector: 'lx-copy-selections-button',
  templateUrl: './copy-quote-selections-button.component.html',
  styleUrls: ['./copy-quote-selections-button.component.scss'],
  imports: [NgOptimizedImage, TooltipModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CopyQuoteSelectionsButtonComponent implements AfterViewInit {
  @ViewChild(Tooltip) private tooltip: Tooltip | undefined;

  valid = input(false);
  copied = input(false);
  copyRequested = output<void>();

  private viewInitialized = false;

  /**
   * Tooltip text that automatically updates when copied state changes.
   * Shows "Link copied" when copied is true, "Copy selections" otherwise.
   */
  protected readonly tooltipText = computed(() => (this.copied() ? $localize`Link copied` : $localize`Copy selections`));

  /**
   * Effect to programmatically show/hide tooltip when copied state changes.
   * This is necessary because the tooltip must appear even when the user hasn't hovered.
   */
  constructor() {
    effect(() => {
      // Guard: Ensure ViewChild is initialized before accessing tooltip API
      if (!this.viewInitialized || !this.tooltip) {
        return;
      }

      if (this.copied()) {
        this.tooltip.show();
      } else {
        this.tooltip.hide();
      }
    });
  }

  ngAfterViewInit(): void {
    this.viewInitialized = true;
  }

  protected copyToClipboard(): void {
    this.copyRequested.emit();
  }

  protected onMouseLeave(): void {
    this.tooltip?.hide?.();
  }
}
